import { render, staticRenderFns } from "./PackageListTable.vue?vue&type=template&id=49c2fa9c"
import script from "./PackageListTable.vue?vue&type=script&lang=js"
export * from "./PackageListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports